<script setup lang="ts">
import SmallModel from '@/components/Interface/Modal/ModelSizes/SmallModel.vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { useNewsSettingsStore } from '@/stores/newsSettingsStore.ts'
import ToggleSwitch from '@/components/Interface/ToggleSwitch/ToggleSwitch.vue'

const newsSettings = useNewsSettingsStore()

const updateMinimumShipsPerSide = (event: Event) => {
  const target = event.target as HTMLInputElement
  newsSettings.setMinimumShipsPerSide(parseInt(target.value))
}
</script>

<template>
  <SmallModel title="News Settings">
    <StandardCard class="p-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">Hide Small Battles</div>
          <small class="text-gray-500"> Hide all battles where one side has less than X ships </small>
        </div>
        <div>
          <ToggleSwitch v-model="newsSettings.hideSmallBattles" />
        </div>
      </div>
    </StandardCard>
    <StandardCard class="px-2 pb-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">Minimum Ships Per Side</div>
          <small class="text-gray-500"> Both sides must have at least this many ships </small>
        </div>
        <div class="flex items-center">
          <input 
            type="range" 
            min="1" 
            max="50" 
            step="1"
            :value="newsSettings.minimumShipsPerSide"
            @input="updateMinimumShipsPerSide"
            class="w-20 h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer mr-2"
          />
          <span class="text-slate-300 min-w-[3ch]">{{ newsSettings.minimumShipsPerSide }}</span>
        </div>
      </div>
    </StandardCard>
  </SmallModel>
</template>

<style scoped lang="scss">
input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background: #64748b;
  cursor: pointer;
}

input[type="range"]::-moz-range-thumb {
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background: #64748b;
  cursor: pointer;
  border: none;
}
</style> 